const t = {
  name: "DownUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 4H22V2H21C15.255 2 10.383 5.72231 8.66321 10.8879C7.38993 9.13841 5.32641 8 3 8H2V10H3C5.75772 10 8 12.2423 8 15V18H10V15C10 8.92228 14.9223 4 21 4Z" fill="currentColor"/>
<path d="M13 20H5V22H13V20Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as DownUp
};
